type ButtonHandler = (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => void;

export interface GalleryItemProps {
  id: string;
  url: string | null;
  isLoading: boolean;
  handleDelete: ButtonHandler;
  handleRotateRight: ButtonHandler;
  handleRotateLeft: ButtonHandler;
}

export enum PhotoButtonEnum {
  Delete = 'delete',
  RotateLeft = 'rotate-left',
  RotateRight = 'rotate-right'
}

export interface PhotoButtonProps {
  type: PhotoButtonEnum;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
